export const COMPLIANCE_GET_POSTS_ATTEMPT = 'COMPLIANCE_GET_POSTS_ATTEMPT'
export const COMPLIANCE_GET_POSTS_SUCCESS = 'COMPLIANCE_GET_POSTS_SUCCESS'
export const COMPLIANCE_GET_POSTS_FAILURE = 'COMPLIANCE_GET_POSTS_FAILURE'
export const COMPLIANCE_SET_POSTS = 'COMPLIANCE_SET_POSTS'
export const SHOW_POSTER = 'SHOW_POSTER'
export const COMPLIANCE_SET_UPDATES = 'COMPLIANCE_SET_UPDATES'
export const COMPLIANCE_GET_UPDATES_ATTEMPT = 'COMPLIANCE_GET_UPDATES_ATTEMPT'
export const COMPLIANCE_SHOW_LOADING = 'COMPLIANCE_SHOW_LOADING'

export default {
  COMPLIANCE_GET_POSTS_ATTEMPT,
  COMPLIANCE_GET_POSTS_SUCCESS,
  COMPLIANCE_GET_POSTS_FAILURE,
  COMPLIANCE_SET_POSTS,
  SHOW_POSTER,
  COMPLIANCE_SET_UPDATES,
  COMPLIANCE_GET_UPDATES_ATTEMPT,
  COMPLIANCE_SHOW_LOADING
}
